

















import { computed, defineComponent, PropType, ref, toRefs, watch } from '@nuxtjs/composition-api'
import { serviceSearchOptionValue } from '~/stub/apigateway/master/master_pb'
import { ConditionOption } from '~/stub/apigateway/service/search_pb'

const serviceSearchHeaderFacetCassette = defineComponent({
  name: 'ServiceSearchHeaderFacetCassette',
  components: {},
  props: {
    optionValueMaster: {
      type: Object as PropType<serviceSearchOptionValue.AsObject>,
      default: null
    },
    conditionOption: {
      type: Object as PropType<ConditionOption.AsObject>,
      default: null
    },
    allowsMultipleSelect: {
      type: Boolean,
      default: false
    },
    iconImage: {
      type: String as PropType<string>,
      default: ''
    },
    isSearchIcon: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    isScrolling: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  computed: {
    innerValue: {
      get() {
        return this.conditionOption.value
          ? [this.conditionOption.value]
          : this.conditionOption.valuesList
      },
      set(val) {
        if (this.allowsMultipleSelect) {
          this.$emit('input', val)
        } else if (val.some(v => Number(v) === Number(this.optionValueMaster.value))) {
          this.$emit('input', [Number(this.optionValueMaster.value)])
        } else {
          this.$emit('input', [])
        }
      }
    }
  },
  setup(props) {
    const isDisabled = ref<boolean>(false)
    const { isScrolling, isSearchIcon, iconImage } = toRefs(props)

    const computedStyle = computed(() => {
      if (isSearchIcon.value) {
        return {
          backgroundImage: `url(${iconImage.value})`
        }
      }
      return null
    })

    watch(isScrolling, newValue => {
      if (!newValue) {
        setTimeout(() => {
          isDisabled.value = false
        }, 100)
      } else {
        isDisabled.value = true
      }
    })
    return {
      computedStyle,
      isDisabled
    }
  }
})

export default serviceSearchHeaderFacetCassette
